// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

export function confrontarDigitaisIIRGDRequest(
	rgSp: string,
	dedo: string,
	digital: ArrayBuffer,
	token: string,
): ReducerActionRotaSP {
	return {
		type: Types.CONFRONTAR_DIGITAIS_IIRGD_REQUEST,
		token,
		payload: {
			rgSp,
			dedo,
			digital,
		},
	};
}
export function confrontarDigitaisIIRGDSuccess(): ReducerActionRotaSP {
	return {
		type: Types.CONFRONTAR_DIGITAIS_IIRGD_SUCCESS,
		payload: null,
	};
}
export function confrontarDigitaisIIRGDFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONFRONTAR_DIGITAIS_IIRGD_FAILURE,
		payload: null,
	};
}
export function confrontarDigitaisIIRGDClear(): ReducerActionRotaSP {
	return {
		type: Types.CONFRONTAR_DIGITAIS_IIRGD_CLEAR,
		payload: null,
	};
}
